const postReducer = (state, action) => {
  switch (action.type) {   
    default: 
      return state;
  }
}

export { postReducer as default }